export default {
    install: (Vue) => {

        Vue.filter('toCurrency', function(value) {
            if (isNaN(value)) return value;
            let val = (value/1).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        });

        Vue.filter("toUpper", (text) => {
            if(text == null || text == undefined || text === "") return "";
            if(typeof text != "string") return text;
            return text.toUpperCase();
        });

        Vue.filter("toInteger", (text) => {
            if(text == null || text == undefined || text === "") return "";
            if(typeof text != "string") return text;
            var num = text.match(/[\d]+/g);
            return num ? num.join("").toString() : "";
        });

        Vue.filter("toMinMax", (text, min, max) => {
            if(text == null || text == undefined || text === "") return "";
            if(isNaN(text)) return text;
            if(min == undefined) min = 0;
            if(max == undefined) max = 999999999999999999; // 999.999"999,999'999,999.00
            var num = text * 1;
            min = min * 1;
            max = max * 1;
            if(num > max) return max;
            if(num < min) return min;
            return num;
        });

        Vue.filter("toPercentage", (text, max) => {
            if(text == null || text == undefined || text === "") return "";
            if(typeof text != "string") return text;
            if(max == undefined) max = 100;
            if(text == "0") text = "0.";
            var num = text.match(/([1-9]\d*(\.\d{0,2})?|0\.\d{0,2})/g);
            if(num == null) return 0.01;
            num = num[0];
            if(num * 1 > max) return max;
            if(num * 1 < 0) return 0.01;
            return num;
        });
        
        Vue.filter("toName", (text) => {
            if(text == null || text == undefined || text === "") return "";
            if(typeof text != "string") return text;
            var num = text.match(/[^0-9_!¡÷·?¿/\\+=@@#$%€¬ˆ&*(){}|~<>;:\[\]]+/g); //eslint-disable-line
            return num ? num.join("").toString() : "";
        });
        
        Vue.filter("toAlphanumeric", (text) => {
            if(text == null || text == undefined || text === "") return "";
            if(typeof text != "string") return text;
            var num = text.match(/[0-9A-Za-z]+/g); //eslint-disable-line
            return num ? num.join("").toString() : "";
        });
        
        Vue.filter("isEmail", (text) => {
            if(text == null || text == undefined || text == "") return false;
            if(typeof text != "string") return false;
            var num = text.match(/(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi); //eslint-disable-line
            if(num) return true;
            else return false;
        });
        
        Vue.filter("isWebsite", (text) => {
            if(text == null || text == undefined || text == "") return false;
            if(typeof text != "string") return false;
            var num = text.match(/(https?:\/\/)?(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/gi); //eslint-disable-line
            if(num) return true;
            else return false;
        });
        
        Vue.filter("limit", (text, length) => {
            if(text == null || text == undefined || text === "") return "";
            if(typeof text != "string") text = text.toString();
            if(text.length <= length) return text;
            return text.slice(0, length);
        });

        
        Vue.filter('BNBMoneda', (value) => {
            if(isNaN(value)) return value;

            switch(value * 1) {
                case 0: return "BOB";
                case 1: return "USD";
                case 16: return "EUR";
            }

            return value;
        });

    }

};
